/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import ActivityEvent from '../../event/ActivityEvent'
import { ActivityState } from '../state/ActivityState'

class ActivitiesStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ActivityEvent.onSearch:
        if (!payload || !payload.activities) {
          return state
        }

        const activities = payload.activities.map(activity => new ActivityState(activity))
        return List(activities)
      default:
        return state
    }
  }
}

export default new ActivitiesStore()
